import { logger } from '@gem/modules/logger';

import { IClientConfigProperty } from 'APP/model/auth/authModel.types';
import Entities from 'STORE';
import { ClientConfigStoreKey } from 'STORE/ClientConfig/ClientConfig';

export enum OnboardingFeatures {
  CollectionsIntro = ClientConfigStoreKey.OnboardingCollectionsIntro,
}

interface OnboardingItem {
  feature: OnboardingFeatures;
  url: string;
}

export function handleOnboarding(property: IClientConfigProperty): void {
  try {
    const onboardings: OnboardingItem[] = JSON.parse(property.value);

    if (!Array.isArray(onboardings)) {
      return;
    }

    onboardings.forEach((onboarding) => {
      switch (onboarding.feature) {
        case OnboardingFeatures.CollectionsIntro:
          Entities.clientConfig.setConfig(
            ClientConfigStoreKey.OnboardingCollectionsIntro,
            onboarding.url
          );
      }
    });
  } catch (error) {
    logger.get('clientConfig').error('handleOnboarding', error);
  }
}
